module.exports = __webpack_public_path__ + "static/media/circles.d0e8ded9.svg";